import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { ImageLoaderCmp } from './image-loader-component';
import { ImageLoaderController } from './image-loader';

export { ImageLoaderController } from './image-loader';


export class ImageLoaderModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: ImageLoaderModule,
      providers: [
        ImageLoaderController
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    IonicModule
  ],
  exports: [
    ImageLoaderCmp
  ],
  declarations: [
    ImageLoaderCmp
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
